import React, { useEffect, useState } from "react";

import { ShowError } from "../../../components/error";
import { Title } from "./title";
import { Value } from "./value";
import { fetchHcfDetails } from "./api";
import styled from "styled-components";
import { showErrorToast } from "@src/appV2/lib/Notifications";

const Container = styled.div`
  margin-bottom: 10px;
`;

function RushCharge({ hcfId, updateFacility }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [details, setDetails] = useState<any>();
  const [error, setError] = useState();

  useEffect(() => {
    fetchHcfDetails(hcfId, "rushFee").then(setDetails).catch(setError);
  }, [hcfId]);

  const updateLocal = (data) => {
    setDetails((prev) => ({ ...prev, rushFee: data.facility.rushFee }));
  };

  const handleChange = (data) => {
    updateFacility({
      facilityId: hcfId,
      rushFee: data,
    })
      .then(updateLocal)
      .catch(() => showErrorToast("Unable to update workplace rush charge"));
  };

  return (
    <Container>
      <Title>Shift Rush Charge (added to Worker Base Charge)</Title>
      <ShowError error={error} message="Unable to fetch workplace Late Cancel Charge" />
      <p className="content">
        Shift created within
        <Value name="period" onChange={handleChange} value={details?.rushFee?.period} />
        hrs of shift start will have
        <Value name="differential" onChange={handleChange} value={details?.rushFee?.differential} />
        /hr added to the Workplace Base Charge.
      </p>
    </Container>
  );
}

export { RushCharge };
